<template>
  <div>
    <div>
      <div class="main-ttl container-xl">
        <h2>
          <span>{{ headingTitle }}</span>
          <small>{{ headingDesc }}</small>
        </h2>
      </div>

      <main class="container-xl">
        <div class="primary-area setting-area bg-none-sm">
          <HeaderSetting />

          <div class="outside-ttl-sm">
            <div class="section-ttl list-btn-area">
              <h3>監視デバイス</h3>
              <Button @click="add">
                <Icon add />
                <span>監視デバイス登録</span>
              </Button>
            </div>

            <div v-if="items.length === 0" class="add-item frame-dashed mb-5">
              <a href="#" class="link-area" @click.prevent="add"></a>
              <p>まだ監視するデバイスが<span>登録されていません。</span></p>
              <button class="btn btn-main" @click.prevent="add">
                <div class="ico-base ico-add"><div class="ico-plus"></div></div>監視デバイス登録
              </button>
            </div>

            <div v-else>
              <ul class="flex list-unstyled small list-head monitor-list-heading">
                <li class="device-name">監視デバイスID</li>
                <li class="device-condition">利用状況</li>
                <li class="update-detail">支払いサイクル</li>
                <li class="column-ico">設定</li>
              </ul>
              <ul class="list-unstyled setting-list monitor-list">
                <ListItem
                  :key="index"
                  :item="item"
                  v-for="(item, index) in items"
                />
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
/*　ライブラリ */
import { mapGetters, mapActions } from "vuex";

import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

import { Button, Icon } from "components";
import { HeaderSetting } from "containers";
import { SampleImage1 } from "img";
import { SettingIcon } from "icons";
import {
  ListItem,
} from "components/monitoring-devices";

import { RepositoryFactory } from "repositories/factory";

const MonitoringDevicesRepository = RepositoryFactory.get("monitoring-devices");

export default {
  name: "MonitoringDeviceList",
  components: {
    ListItem,
    Button,
    Icon,
    HeaderSetting,
  },
  data() {
    return {
      icons: {
        SettingIcon,
      },
      images: {
        SampleImage1,
      },
      headingTitle: "サービスアカウント設定",
      headingDesc: "サービスアカウントの登録情報です。",
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
      /* アプリステータス */
      screenStatusCd: "application/screenStatusCd",
      isScreenActive: "application/isScreenActive",
      isScreenLoading: "application/isScreenLoading",
      /* 監視デバイスの削除通知 */
      deleteMonitoringDeviceNotificationFlag:
        "application/deleteMonitoringDeviceNotificationFlag",
    }),
  },
  async created() {
    /* 初期化処理 */
    try {
      this.items = await MonitoringDevicesRepository.index(this.currentAsigProject.asigProjectId);
      console.log(this.items);
      console.log(Button);
      console.log(ListItem);
      /* 通知処理　*/
      if (this.deleteMonitoringDeviceNotificationFlag === true) {
        this.setNotification({
          message: "監視デバイスを削除しました。",
        });
        await this.updateDeleteMonitoringDeviceNotificationFlag(false);
      }
      await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    } catch (err) {
      console.log(err);
      this.setErrorNotification({
        message: "予期せぬエラーが発生しました。",
      });
    }
  },
  methods: {
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotificaton: "notification/resetState",
      setNotification: "notification/setNotification",
      setErrorNotification: "notification/setErrorNotification",
      updateDeleteMonitoringDeviceNotificationFlag:
        "application/updateDeleteMonitoringDeviceNotificationFlag",
    }),
    /* イベントハンドラ */
    add() {
      this.$router.push("/monitoring-devices/create");
    },
    details(monitoringDevice) {
      this.$router.push(`/monitoring-devices/${monitoringDevice.monitoringDeviceId}`);
    },
    edit(monitoringDevice) {
      this.$router.push(`/monitoring-devices/edit/${monitoringDevice.monitoringDeviceId}`);
    },
    isContractTerminating(index) {
      const goodStatus = ["active", "inactive", "standby"];
      const { monitoringDeviceStatus, subscriptionAutoRenewal } =
        this.items[index];
      if (
        goodStatus.includes(monitoringDeviceStatus) &&
        subscriptionAutoRenewal === "off"
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>
